const KIOSK_LITE_TRANSLATION_KEYS = Object.freeze({
  'cart.software.usageUnitTypes.fnb_kiosk_device': 'kioskLite.hardwareUnit',
  'cart.software.kioskPnp.deviceName': 'kioskLite.name',
  'cart.software.kioskPnp.devicePriceBreakdown':
    'kioskLite.devicePriceBreakdown',
  'productPage.software.disclaimer.sw-kiosk': 'kioskLite.disclaimer',
  'relations.addOn.label.software_kiosk': 'kioskLite.addOnLabel',
  'relations.addOnOverride.sw-kiosk.devicePriceBreakdown':
    'kioskLite.addOnDevicePriceBreakdown',
});

/** Select renamed legacy kiosk copy without changing other products or flag-off copy. */
export const getKioskSoftwareTranslationKey = (key, kioskLiteEnabled = false) =>
  (kioskLiteEnabled && KIOSK_LITE_TRANSLATION_KEYS[key]) || key;
